import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { lastValueFrom, Observable, Subject } from "rxjs";
import { cigaroUser } from "../models/user";
import { DisplayloadingService } from "./displayloading.service";
import { PopoverController } from "@ionic/angular";
import { Router } from "@angular/router";
import { YesNoPopupComponent } from "../popovers/yes-no-popup/yes-no-popup.component";
import { SmokingprotocolService } from "./smokingprotocol.service";
import { Humidor } from "../models/humidor";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private api = environment.apiUrl;
  private userSubject = new Subject<cigaroUser>();
  private user: cigaroUser = null;
  constructor(
    private http: HttpClient,
    private ls: DisplayloadingService,
    private popc: PopoverController,
    private router: Router,
    private sps: SmokingprotocolService,
  ) {}

  /**
   *
   * @param email
   * @param pw
   *
   *
   *
   */
  public async login(email: string, pw: string) {
    await this.ls.presentLoading();
    //login mit EMail und Passwort
    this.http
      .post<{ token: string; user: any }>(`${this.api}/account/login.php`, {
        email: email,
        passwort: pw,
      })
      .subscribe({
        next: async (response) => {
          //console.log(response)
          const user = response.user;
          console.log("user who logged in");
          console.log(user);
          this.sps.setSPCount(user.sp_count);
          this.user = new cigaroUser(
            user.id,
            user.email,
            user.language,
            user.theme,
            user.humidors,
            response.token,
            user.sp_count,
            user.humidor_view,
            user.role,
          );
          this.userSubject.next(this.user);
          await this.ls.presentMessage(
            "displayloading-service.user-loggedin",
            2000,
            "success",
          );
          let link1sthumi: string =
            "folder/humidor/" + this.user.humidors[0].id;
          await this.router.navigate([link1sthumi]);
        },
        error: async (error) => {
          //Account noch nicht aktiviert
          if (error.status == 401) {
            //console.log(error.error.message)
            switch (error.error.message) {
              case "not activated":
                const popover = await this.popc.create({
                  component: YesNoPopupComponent,
                  componentProps: {
                    userMail: email,
                    questionType: "send-activation-mail",
                  },
                  backdropDismiss: false,
                });
                await popover.present();
                await this.ls.hideLoading();
                const answer = await popover.onDidDismiss();
                if (answer.data.answer === true) {
                  this.resend_activation_link(email);
                }
                break;
              default:
                this.ls.presentMessage(
                  "displayloading-service.user-invaliddata",
                  2000,
                  "error",
                );
            }
          }
          //Account nicht existent
          if (error.status == 404) {
            this.ls.presentMessage(
              "displayloading-service.doesnt-exist",
              2000,
              "error",
            );
          }
        },
      });
  }
  /**
   * Falls ein Benutzer seinen Account nicht rechtzeitig aktiviert hat, kann
   * er nochmal einen Aktivierungslink anfordern
   * @param email
   */
  private async resend_activation_link(email: string) {
    this.ls.presentLoading().then(() => {
      this.http
        .post<any>(environment.apiUrl + "/account/resend_activationlink.php", {
          email: email,
        })
        .subscribe(
          async (response) => {
            //console.log(response);
            if (
              response.activation_mail !== "undefined" &&
              response.activation_mail === "sent"
            ) {
              let successMessage =
                "displayloading-service.activation-mail-sent";
              this.ls.presentMessage(successMessage, 2000, "success", true, {
                usermail: email,
              });
            }
          },
          (error) => {
            //console.log(error);
            if (error.status == 409) {
              this.ls.presentMessage(
                "displayloading-service.already-exists",
                2000,
                "error",
              );
            }
          },
        );
    });
    await this.ls.hideLoading();
  }
  /**
   * Ausloggen
   * remove user-object anywhere
   */
  async logout(): Promise<boolean> {
    localStorage.removeItem("user");
    this.user = null;
    this.userSubject.next(this.user);
    await this.ls.presentMessage(
      "displayloading-service.user-loggedout",
      2000,
      "success",
    );
    return true;
  }
  /**
   * Abonnement für User-Object
   * @returns
   */
  public getUserUpdateListener(): Observable<cigaroUser> {
    return this.userSubject.asObservable();
  }
  /**
   *
   * @returns cigarUser-Object
   */
  public getCigaroUser(): cigaroUser {
    if (this.user !== null) {
      return this.user;
    } else {
      //aus localStorage holen
      let user = JSON.parse(localStorage.getItem("user"));
      if (user !== null) {
        this.user = new cigaroUser(
          user.id,
          user.email,
          user.language,
          user.theme,
          user.humidors,
          user.token,
          user.sp_count,
          user.humidor_view,
          user.role,
        );
        this.sps.setSPCount(user.sp_count);
        return this.user;
      } else {
        this.user = null;
        return null;
      }
    }
  }

  /**
   * @description
   * Gibt Nutzer-Objekt als Promise zurück, falls vorhanden
   * @returns Nutzer als Promise
   */
  public async iPromiseaUser(): Promise<cigaroUser> {
    if (this.user !== null) {
      return this.user;
    } else {
      //aus localStorage holen
      let user = JSON.parse(localStorage.getItem("user"));
      if (user !== null) {
        this.user = new cigaroUser(
          user.id,
          user.email,
          user.language,
          user.theme,
          user.humidors,
          user.token,
          user.sp_count,
          user.humidor_view,
          user.role,
        );
        this.sps.setSPCount(user.sp_count);
        return this.user;
      } else {
        this.user = null;
        return null;
      }
    }
  }

  /**
   * Passwort-Reset-Mail
   * @param email
   * @returns
   */
  public sendPWResetMail(email: string): boolean {
    this.ls.presentMessage(
      "reset-pw-popover.mail-send",
      8000,
      "success",
      true,
      { usermail: email },
    );

    this.http
      .post<any>(environment.apiUrl + "/account/reset_pw_mail.php", { email: email })
      .subscribe(
        async (response) => {
          if (
            response.reset_pw_mail !== "undefined" &&
            response.reset_pw_mail === "sent"
          ) {
            let successMessage = "displayloading-service.reset-pw-mail-sent";
            await this.ls.hideLoading();
            await this.ls.presentMessage(
              successMessage,
              2000,
              "success",
              true,
              { usermail: email },
            );
          }
        },
        (error) => {},
      );
    return true;
  }
  /**
   * Gibt die vom Benutzer bereits bezahlte Humi-Kap als Promise zurück
   */
  public async getPaidCapacity(): Promise<number> {
    if (this.user != null) {
      const paid_cap = await lastValueFrom(
        this.http.post<any>(environment.apiUrl + "/account/get_paid_cap.php", {
          userId: this.user.id,
        }),
      );
      return paid_cap.paid_cap.paid_capacity;
    } else {
      return 0;
    }
  }
  /**
   *
   * @returns Abo-Status
   */
  public async getUserRole(): Promise<void> {
    this.http
      .post<any>(environment.apiUrl + "/account/get_user_role.php", "")
      .subscribe((userRole) => {
        this.user.role = userRole.role.role;
        localStorage.setItem("user", JSON.stringify(this.user));
        this.userSubject.next(this.user);
      });
  }

  /**
   * Gibt die vom Benutzer bereits bezahlten Protokolle als Promise zurück
   */
  public async getPaidProtocols(): Promise<number> {
    if (this.user != null) {
      const paid_protocols = await this.http
        .post<any>(
          environment.apiUrl + "/smoking_protocol/get_paid_protocols.php",
          { userId: this.user.id },
        )
        .toPromise();
      return paid_protocols.paid_prots.paid_protocols;
    } else {
      return 0;
    }
  }
  /**
   * Humidore am Benutzer-Objekt aktualisieren und
   * Subject aktualisieren, damit Abonnenten informiert werden
   * (Humidor-Komponente und App-Component)
   * @param humidors
   */
  public changeUserHumis(humidors: Humidor[]) {
    this.user.humidors = humidors;
    localStorage.setItem("user", JSON.stringify(this.user));
    this.userSubject.next(this.user);
  }

  /**
   *
   * @param newrole
   * Ändert die Nutzerrolle, nachdem sich der Abostatus geändert hat
   */
  public changeUserRole(newrole: string) {
    this.user.role = newrole;
    localStorage.setItem("user", JSON.stringify(this.user));
    this.userSubject.next(this.user);
  }

  /**
   * Aktualisiert das Local Storage und das User-Subject mit übergegebenem
   * Nutzerobjekt
   * @param user
   */
  public async refreshUser(user: cigaroUser) {
    this.user = user;
    localStorage.setItem("user", JSON.stringify(this.user));
    this.userSubject.next(this.user);
  }
}
